<script>
    import {onMount} from "svelte";
    import gsap from "gsap";

    const gnosisBlinkTimeline = gsap.timeline({repeat: 1, yoyo: true});
    const gnosisSprites = Array.from(new Array(7)).map((_, i) => 'images/Gnosis0' + i + '.png');

    let blinker;

    onMount(() => {

        gnosisSprites.forEach((href) => {
            gnosisBlinkTimeline
                .call(() => {
                    blinker.setAttribute('href', href);
                }, null, '>+=0.041');
        });

        setInterval(() => {
            if (Math.random() > 0.8) {
                gnosisBlinkTimeline.play(0);
            }
        }, 1000)

    });

</script>

<svg width="400" height="650" x="780" y=200 viewBox="0 0 400 650">
    <image bind:this={blinker} id="blinking-gnosis" width="400" height="650" href="images/Gnosis00.png" />
</svg>
